module.exports = __webpack_public_path__ + "assets/surface.736dab50.svg";